import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right-icon.svg";

const HeroContainer = styled.div`
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e5e7eb;
`;

const HeroBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0c4d96;
  color: white;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  margin-bottom: 1rem;
  letter-spacing: 0.03em;

  &::before {
    content: "✦";
    font-size: 8px;
    color: #7eb8ff;
  }
`;

const HeroTitle = styled.h1`
  font-size: 1.6rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 0.75rem 0;
  letter-spacing: -0.01em;
  line-height: 1.25;

  @media (min-width: 768px) {
    font-size: 1.85rem;
  }
`;

const HeroSubtitle = styled.p`
  color: #4b5563;
  font-size: 0.95rem;
  margin: 0 0 1.5rem 0;
  line-height: 1.7;
  max-width: 480px;
`;

const ContactSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  
  @media (min-width: 480px) {
    grid-template-columns: auto 1fr;
    gap: 2rem;
    align-items: end;
  }
`;

const ContactInfo = styled.div`
  text-align: left;
  color: #374151;
`;

const ContactLabel = styled.div`
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 4px;
  color: #9ca3af;
  font-weight: 600;
`;

const ContactDepartment = styled.div`
  font-size: 0.85rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 2px;
`;

const ContactDetails = styled.div`
  font-size: 0.78rem;
  font-weight: 400;
  color: #6b7280;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  
  @media (min-width: 480px) {
    justify-content: flex-end;
  }
`;

const ApplyButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: transparent;
  color: #0c4d96;
  padding: 8px 18px;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1.5px solid #0c4d96;
  border-radius: 30px;
  white-space: nowrap;

  &:hover {
    background: #0c4d96;
    color: white;
  }

  svg {
    width: 12px;
    height: 12px;
    transition: transform 0.2s;
  }

  &:hover svg {
    transform: translateX(2px);
  }
`;

export default function RecruitmentHero() {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <HeroBadge>{t("recruitment_hero.badge")}</HeroBadge>
      <HeroTitle>{t("recruitment.subheading")}</HeroTitle>
      <HeroSubtitle>{t("recruitment.description.subtitle")}</HeroSubtitle>
      
      <ContactSection>
        <ContactInfo>
          <ContactLabel>{t("recruitment_hero.contact_label")}</ContactLabel>
          <ContactDepartment>{t("recruitment_hero.department")}</ContactDepartment>
          <ContactDetails>{t("recruitment_hero.phone_fax")}</ContactDetails>
        </ContactInfo>
        <ButtonWrapper>
          <ApplyButton
            href="https://www.unics-holdings.co.jp/saiyo/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("recruitment.linkText")}
            <ArrowRightIcon />
          </ApplyButton>
        </ButtonWrapper>
      </ContactSection>
    </HeroContainer>
  );
}
